import React from 'react';

import { observer } from 'mobx-react-lite';

import { ExtractPromiseSuccess } from '^/types/__ResultType';
import { ExtractMapIterator } from '^/types/__utils';

import { StanzonePushSentTypeView } from './StanzonePushSentTypeView';
import { StanzonesListPageStyleType } from './StanzonesListPage.styles';
import { StanzonesListPageViewModel } from './StanzonesListPage.viewmodel';

type A = StanzonesListPageViewModel['stanzonesListCollapsed'];

type B = ExtractPromiseSuccess<A>;
type C = ReturnType<B['values']>;
type D = ExtractMapIterator<C>;

export const StanzonesListPageItemsRenderer: React.FC<{
  groupedStanzones: D;
  styles: StanzonesListPageStyleType;
}> = observer(function StanzonesListPageItemsRenderer(p) {
  const { styles } = p;
  const toRender = p
    .groupedStanzones
    .map(([
      sameStatusDate,
      stanzones,
    ]) => {
      const firstStanzone = stanzones.first();
      if (!firstStanzone) {
        return (
          <h1> IMPOSSIBLE_CASE_STANZONE_EMPTY_BUT_GROUPED ????? </h1>
        );
      }
      const isOpen = !firstStanzone.isUp;
      const statusText = isOpen
        ? '열림 ✅'
        : '잠김 🔒';
      const stanzonesToRender = isOpen
        ? stanzones.filter((s) => {
          return s.pushType !== 'NO_NEED_TO_SEND' && s.pushType !== 'NOT_SENT_YET';
        }) : stanzones;
      const renderedStanzones = stanzonesToRender
        .map((stanzone) => {
          const imgUrl = stanzone.imageUrl || '';
          return (
            <div
              key={stanzone.id}
              className={styles.itemSlideItem}
            >
              <img
                className={styles.itemSlideItemImage}
                alt=""
                src={imgUrl}
                loading="lazy"
              />
              <div
                className={styles.itemDescriptionTop}
              >
                <p>
                  {stanzone.createdAt.toLocaleString()}
                </p>

                <div
                  className={styles.itemGroupedCount}
                >
                  {stanzone.pushType !== 'NO_NEED_TO_SEND' && '🔔'}
                </div>
              </div>
              <div>
                <span>
                  {statusText}
                </span>
                <StanzonePushSentTypeView
                  stanzone={stanzone}
                  eventTime={stanzone.createdAt}
                />
              </div>
            </div>
          );
        });
      return (
        <>
          {renderedStanzones.toArray()}
        </>
      );
    })
    .toArray();

  return (
    <>
      {toRender}
    </>
  );
});
